module.exports = "/favicon-rc.png?aL7rBlE";